module.exports = __webpack_public_path__ + "img/bd_expat.png";